import { DailyAccounting } from "../types/daily-accounting";
import { Cents, Money } from "../types/money";
import { FirestoreService } from "./firestore";

export namespace AccountingService {
  export const get = async (date: string) =>
    FirestoreService.getDocument<DailyAccounting>(DailyAccounting.path(date));

  export const save = async (
    date: string,
    input: { disputes: Cents; threeDsCount: number; updatedBy: string },
  ): Promise<DailyAccounting> => {
    const record: DailyAccounting = {
      date,
      disputes: Money.create(input.disputes),
      threeDsCount: input.threeDsCount,
      updatedAt: new Date().toISOString(),
      updatedBy: input.updatedBy,
    };

    DailyAccounting.schema.parse(record);
    await FirestoreService.setDocument(DailyAccounting.path(date), record);
    return record;
  };
}
